import React, {useState, useEffect} from "react"
import {MDBContainer, MDBRow, MDBCol,MDBBtn} from 'mdbreact'
import classes from './AdminLayout.module.css'
import {Link, Route, Switch, withRouter} from "react-router-dom";
import LoginPage from "../LoginPage/LoginPage";
import {faKey, faSpider, faUserCheck} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ApprovalPage from "./ApprovalPage/ApprovalPage";
import {connect} from "react-redux";
import ScraperPage from "./ScraperPage/ScraperPage";
import {generateSiteMap} from "../../Utils/category";

const AdminLayout = (props) => {
    return (
        <MDBContainer>
            <MDBRow>
                <MDBCol xl="12" lg="12" md="12" sm={12} xs="12">
                    <div className={classes.FunctionGrid}>
                        <Link to={'/admin/approve'}>
                            <div className={classes.GridItem}>
                                <FontAwesomeIcon icon={faUserCheck} className={classes.Icon}/>
                            </div>
                        </Link>
                        <Link to={'/admin/scraper'}>
                            <div className={classes.GridItem}>
                                <FontAwesomeIcon icon={faSpider} className={classes.Icon}/>
                            </div>
                        </Link>

                        <MDBBtn onClick={() => generateSiteMap()}>Generate Sitemap</MDBBtn>
                    </div>
                </MDBCol>

            </MDBRow>

            <MDBRow>
                <MDBCol xl="12" lg="12" md="12" sm={12} xs="12">
                    <Switch>
                        <Route path="/admin/approve" exact>
                            <ApprovalPage auth={props.auth}/>
                        </Route>
                        <Route path="/admin/scraper" exact>
                            <ScraperPage auth={props.auth}/>
                        </Route>
                    </Switch>
                </MDBCol>

            </MDBRow>


        </MDBContainer>
    )
}
const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(AdminLayout))
